import { Layout, ChatBot } from '@components/commons';
import LandingLandlord from '@components/LandingPages/LandingLandlord/LandingLandlord';
import { isColombia } from '@shared/utils';
import { GetServerSidePropsContext } from 'next';
import React from 'react';

export const getServerSideProps = async ({ locale }: GetServerSidePropsContext) => {
  return {
    props: {
      messages: (await import(`../locales/${locale?.toLowerCase()}.json`)).default,
    },
  };
};

const PageLandlord = () => {
  return (
    <Layout>
      <LandingLandlord />
      { isColombia() && <ChatBot />}
    </Layout>
  );
};

export default PageLandlord;
